//Imports
import React, { useContext, useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
//Import Firebase
import { auth, db } from "../../firebase";
import { signOut } from "firebase/auth";
import { doc, Timestamp, updateDoc } from "firebase/firestore";
//Imports contexts
import { AuthContext } from "../../contexts/AuthContext";
import { AppContext } from "../../contexts/AppContext";
//Imports Helpers
import { getDepartmentURL, sortNotificationsByDate, sortNotificationsByDate2, getSentTo, formatCurrencyWithNull, isProjectActive } from "../../shared/helpers";
import useNotifications from "../../shared/useNotifications";
//Imports components
import NavBar from "../../ui-components/navBar/NavBar";
import ProjectInactive from "../../ui-components/containers/projectInactive/ProjectInactive";
import HomeContent from "./HomeContent";
import Loading from "../../shared/ui-loading/Loading";
import '../../shared/ui-quickAccess/quickAccess.css';
//Imports Icons
import userLogo from '../../assets/icons/userLogo.svg';
import userLogoPurple from '../../assets/icons/userLogoPurple.svg';
import notification from '../../assets/icons/notification.svg';
import settingsLogo from '../../assets/icons/settingsLogo.svg';
//Import CSS
import './home.css';

function Home() {
    const { setCurrentUser, userData, loading } = useContext(AuthContext);
    const { requestsList, dataProjects, isLoading: projectsLoading } = useContext(AppContext);
    const [showMenu, setShowMenu] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    // const [activeNotifications, setActiveNotifications] = useState([]);
    const [isNavOpen, setIsNavOpen] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const isProjectInactive = !loading && userData && dataProjects.length > 0 &&
        userData?.permissions !== 'admin' &&
        (!isProjectActive(userData?.tenantId, dataProjects));

    const isReportRoute =
        location.pathname.includes('/finanzas') ||
        location.pathname.includes('/finanzas/ejecucionPME') ||
        location.pathname.includes('/finanzas/presupuesto');

    const { activeNotifications } = useNotifications(userData, requestsList);

    useEffect(() => {
        // Cerrar menús o restablecer estados cuando cambia la ruta
        setShowMenu(false);
        setShowNotifications(false);
        setIsNavOpen(false);
    }, [location.pathname]);



    useEffect(() => {
        if (isProjectInactive && location.pathname !== '/' && !isReportRoute) {
            navigate('/', { replace: true });
        }
    }, [isProjectInactive, location.pathname, isReportRoute, navigate]);

    // useEffect(() => {
    //     if (!userData) return;

    //     const unsub = onSnapshot(collection(db, 'notifications'), (querySnapshot) => {
    //       const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    //       const filtered = data.filter(n => {
    //         // solo notificaciones relevantes para el usuario
    //         return n.establishmentId === userData.establishmentId && !n.seenBy;
    //       });

    //       setNotificationsList(filtered);
    //     });

    //     return () => unsub();
    //   }, [userData]);

    //Filtrar notificaciones para el usuario actual
    // useEffect(() => {
    //     if (userData && userData.dimension === 'Establecimiento' && userData.establishmentId && notificationsList) {
    //         const filteredNotifications = notificationsList.filter(notification =>
    //             notification.establishmentId === userData.establishmentId &&
    //             !notification.seenBy
    //         );
    //         const sortedNotifications = sortNotificationsByDate(filteredNotifications);
    //         setActiveNotifications(sortedNotifications);
    //     } else if (userData && userData.dimension === 'Sostenedor' && userData.tenantId && requestsList) {
    //         const filteredNotifications = requestsList.filter(request =>
    //             getSentTo(request) === userData.department)
    //             .filter(request => request.idProject === userData.tenantId);
    //         const sortedNotifications = sortNotificationsByDate2(filteredNotifications);
    //         setActiveNotifications(sortedNotifications)
    //     }
    // }, [userData, notificationsList, requestsList]);

    useEffect(() => {
        // Función para manejar clics en el documento
        const handleClickOutside = (event) => {
            // Para el menú de usuario
            const userIcon = document.querySelector('img[alt="perfil de usuario"]');
            const menuUser = document.querySelector('.menu-user');

            if (
                showMenu &&
                menuUser &&
                !menuUser.contains(event.target) &&
                userIcon !== event.target
            ) {
                setShowMenu(false);
            }

            // Para el menú de notificaciones
            const notificationIcon = document.querySelector('img[alt="notificaciones"]');
            const notificationPopup = document.querySelector('.notification-popup');

            if (
                showNotifications &&
                notificationPopup &&
                !notificationPopup.contains(event.target) &&
                notificationIcon !== event.target
            ) {
                setShowNotifications(false);
            }
        };

        // Agregar el event listener al documento
        document.addEventListener('mousedown', handleClickOutside);

        // Eliminar el event listener al desmontar el componente
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showMenu, showNotifications]);

    const handleLogOut = async (e) => {
        e.preventDefault();
        try {
            signOut(auth).then(() => {
                console.log('LogOut');
                setCurrentUser(null);
            })
        } catch (error) {
            console.error('No se pudo hacer LogOut');
        }
    }

    const handleClickMenu = (e) => {
        e.preventDefault();
        setShowMenu(!showMenu);
        if (showNotifications) setShowNotifications(false);
    };

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
        if (showMenu) setShowMenu(false);
        if (showNotifications) setShowNotifications(false);
    };

    const closeNav = () => {
        setIsNavOpen(false);
    };

    const handleNotificationClick = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
        if (showMenu) setShowMenu(false);
    };

    const handleNavLinkClick = () => {
        setShowMenu(false);
    };

    const handleViewRequest = async (notification, status) => {
        try {
            //Marcar la notificación como vista
            const notificationRef = doc(db, 'notifications', notification.id);
            await updateDoc(notificationRef, {
                seenBy: userData.uid,
                viewedAt: Timestamp.now()
            });

            //Navegar según status de la solicitud
            setTimeout(() => {
                if (notification.requestType === 'payment') {
                    if (status === 'finished') {
                        navigate(`/establecimiento/seguimiento-pago/${notification.requestId}`);
                    } else if (status === 'partialPayment') {
                        // Navegar a /pagos con estado para preseleccionar la solicitud
                        navigate(`/establecimiento/seguimiento-pago/${notification.requestId}`);
                    } else if (status === 'rejected') {
                        navigate('/establecimiento/pagos');
                    }
                } else {
                    if (status === 'approved') {
                        console.log('navegando a pagos');
                        navigate('/establecimiento/pagos');
                    } else if (status === 'rejected') {
                        navigate(`/establecimiento/seguimiento/${notification.requestId}`);
                    }
                }
                setShowNotifications(false);
            }, 0);
            // if (notification.requestType === 'payment') {
            //     console.log(notification.requestType);
            //     if (status === 'finished') {
            //         navigate(`/establecimiento/seguimiento-pago/${notification.requestId}`);
            //         console.log('navegue a seguimiento-pago');
            //     } else if (status === 'partialPayment') {
            //         // Navegar a /pagos con estado para preseleccionar la solicitud
            //         navigate(`/establecimiento/seguimiento-pago/${notification.requestId}`)
            //     } else if (status === 'rejected') {
            //         navigate('/establecimiento/pagos')
            //     }
            // } else {
            //     if (status === 'approved') {
            //         console.log('navegando a pagos');
            //         navigate('/establecimiento/pagos');
            //     } else if (status === 'rejected') {
            //         navigate(`/establecimiento/seguimiento/${notification.requestId}`);
            //     }
            // }
            // setShowNotifications(false);
        } catch (error) {
            console.error('Error al marcar notificación como vista:', error);
        }
    };

    const handleNavigate = () => {
        if (userData && userData.department) {
            const departmentPath = getDepartmentURL(userData.department);
            navigate(`/sostenedor/${departmentPath}`, { replace: true });
            setShowNotifications(false);
        }
    };

    const getNotificationContent = (notification) => {
        const notificationTypes = {
            rejected: {
                message: notification.requestType === 'payment' ? (
                    <>Tu solicitud de pago {notification.paymentType === 'fullPayment' ? 'total' : 'parcial'} por <strong>{formatCurrencyWithNull(notification.amountRejected)}</strong> ha sido rechazada.</>
                ) : (
                    <>La solicitud folio <strong>Nº {notification.requestFolio}</strong> fue rechazada.</>
                ),
                buttonText: 'Ver',
                action: () => handleViewRequest(notification, 'rejected')
            },
            approved: {
                message: (
                    <>La solicitud folio <strong>Nº {notification.requestFolio}</strong> ha sido aprobada.</>
                ),
                buttonText: 'Crear Sol. Pago',
                action: () => handleViewRequest(notification, 'approved')
            },
            finished: {
                message: (
                    <>Tu solicitud de pago ha sido completada.</>
                ),
                buttonText: 'Ver',
                action: () => handleViewRequest(notification, 'finished')
            },
            partialPayment: {
                message: (
                    <>Haz recibido un pago parcial de <strong>{formatCurrencyWithNull(notification?.amountPaid)}</strong> .</>
                ),
                buttonText: 'Ver',
                action: () => handleViewRequest(notification, 'partialPayment')
            },
            default: {
                message: (
                    <>La solicitud folio <strong>Nº {notification.requestFolio}</strong> requiere tu atención.</>
                ),
                buttonText: 'Ver',
                action: () => handleViewRequest(notification)
            }
        };

        const type = notificationTypes[notification.requestStatus] || notificationTypes.default;

        return (
            <>
                <p>{type.message}</p>
                <button
                    className='button'
                    type='button'
                    onClick={type.action}
                >
                    <p>{type.buttonText}</p>
                </button>
            </>
        );
    };

    if (projectsLoading && userData?.permissions !== 'admin') {
        return (
            <main className='box-main flex'>
                <Loading /> {/* Loading solo en área de contenido */}
            </main>
        );
    }

    return (
        <>
            <div
                className={`nav-overlay ${isNavOpen ? 'show' : ''}`}
                onClick={() => setIsNavOpen(false)}
            ></div>
            <header className='header flex'>
                {userData && !userData.permissions && (
                    <span className='notification-container flex'>
                        <img src={notification} className='icon' alt='notificaciones' onClick={handleNotificationClick} />
                        {activeNotifications.length > 0 && (
                            <span className='notification-badge flex'>
                                {activeNotifications.length}
                            </span>
                        )}
                    </span>
                )}
                <ul className={`notification-popup ${showNotifications ? 'active' : ''} `}>
                    {activeNotifications.length > 0 ? (
                        userData?.dimension === 'Establecimiento' ? (
                            activeNotifications.map(notification => (
                                <li key={notification.id} className='flex'>
                                    {notification && getNotificationContent(notification)}
                                </li>
                            ))
                        ) : (
                            <li className='flex'>
                                <p className='holder' onClick={handleNavigate}>
                                    Tienes <strong>{activeNotifications.length}</strong> solicitudes pendientes por responder.
                                </p>
                            </li>
                        )
                    ) : (
                        <li><p>No Existen notificaciones nuevas</p></li>
                    )}
                </ul>
                <img src={userLogo} className='icon' alt='perfil de usuario' onClick={handleClickMenu} />
                <ul className={`menu-user ${showMenu && 'active'} flex`}>
                    <NavLink to={'perfil'} onClick={handleNavLinkClick}><li className='li-menu'><p>Configuración de perfil</p></li></NavLink>
                    <li className='li-menu' onClick={handleLogOut}><p>Cerrar Sesión</p></li>
                </ul>
                <button
                    className={`hamburguer-btn ${isNavOpen ? 'open' : ''}`}
                    onClick={toggleNav}
                    aria-label='Toggle menu'
                >
                    <span className='hamburguer-line'></span>
                    <span className='hamburguer-line'></span>
                    <span className='hamburguer-line'></span>
                </button>
            </header>
            <section className='section flex'>
                <aside className={`nav flex ${isNavOpen ? 'open' : ''}`}>
                    <article className='user-article'>
                        <div className='user-box flex'>
                            <img src={userLogoPurple} className='icon-user icon-custom' alt='perfil de usuario' />
                            <span className='user-data flex'>
                                <p>
                                    {
                                        userData ? userData.displayName : 'Nombre usuario'
                                    }
                                </p>
                                <p>{!loading && userData
                                    ? (userData.permissions === 'admin' ? 'Administrador' : userData.department)
                                    : 'Departamento'}
                                </p>
                            </span>
                            <NavLink to='perfil' onClick={closeNav}>
                                <img src={settingsLogo} className='icon-user' alt='configuraciones' />
                            </NavLink>
                        </div>
                    </article>
                    <NavBar onNavItemClick={closeNav} />
                </aside>
                <main className='box-main flex'>
                    {isProjectInactive && !isReportRoute ? (
                        <ProjectInactive />
                    ) : (
                        location.pathname === '/' ? (
                            <HomeContent
                                activeNotifications={activeNotifications}
                                getNotificationContent={getNotificationContent}
                                handleNavigate={handleNavigate}
                            />
                        ) : <Outlet key={location.key} />
                    )}
                </main>
            </section>
        </>
    )
}

export default Home;